import app from '@/main'

async function dialogGet ({ userId }) {
  return await app.wsp.sendRequest({
    data: {
      userId: userId
    },
    method: 'dialog.get'
  })
}

export default dialogGet